// CSS do Bootstrap precisa vir antes do App para que os estilos do projeto o sobrescrevam
import './assets/scss/_bootstrap.scss'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import {
  LayoutPlugin,
  ImagePlugin,
  CardPlugin,
  NavbarPlugin,
  CollapsePlugin,
  TooltipPlugin,
  EmbedPlugin
} from 'bootstrap-vue'
import dados from './dados/store'
// import axios from 'axios'


Vue.config.productionTip = false

// import './plugins/axios'

// axios.defaults.headers.get['header-name'] = 'value'

Vue.use('VueRouter')

// Registra apenas os componentes do BootstrapVue usados no site
Vue.use(LayoutPlugin)     // b-container, b-row, b-col
Vue.use(ImagePlugin)      // b-img
Vue.use(CardPlugin)       // b-card, b-card-header, b-card-body, b-card-text
Vue.use(NavbarPlugin)     // b-navbar, b-navbar-nav, b-nav-item, b-navbar-toggle, b-navbar-brand
Vue.use(CollapsePlugin)   // b-collapse, v-b-toggle
Vue.use(TooltipPlugin)    // b-tooltip, v-b-tooltip
Vue.use(EmbedPlugin)      // b-embed



new Vue({
  dados,
  router,
  render: h => h(App)
}).$mount('#app')